// src/components/Carousel.js
import React, { useState, useEffect } from 'react';

// Rutas de las imágenes
const CAROUSEL_IMAGES = [
    '/carousel/slide1.png',
    '/carousel/slide2.png',
    '/carousel/slide3.png',
    '/carousel/slide4.png',
    '/carousel/slide5.png',
];

// Estilo Base para el Contenedor
const heroStyle = { 
    minHeight: '400px', 
    color: 'white', 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    padding: '60px 20px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    transition: 'background-image 1s ease-in-out', // Transición suave entre imágenes
};

const overlayStyle = { 
    position: 'absolute', 
    top: 0, 
    left: 0, 
    width: '100%', 
    height: '100%', 
    backgroundColor: 'rgba(0, 50, 150, 0.6)', // Capa azul semitransparente
};

const contentStyle = { 
    position: 'relative', 
    zIndex: 1, 
    maxWidth: '800px',
};


export default function Carousel() {
    // 1. Estado para saber qué imagen mostrar
    const [currentIndex, setCurrentIndex] = useState(0);

    // 2. Efecto para rotar las imágenes cada 5 segundos
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex(prevIndex => 
                (prevIndex + 1) % CAROUSEL_IMAGES.length // Vuelve al inicio al llegar al final
            );
        }, 5000); // 5000 milisegundos = 5 segundos

        // Limpieza: detiene el intervalo cuando el componente se desmonta
        return () => clearInterval(interval);
    }, []); // El array vacío asegura que solo se ejecute al montar

    // 3. Obtiene la URL de la imagen actual
    const currentImageUrl = CAROUSEL_IMAGES[currentIndex];

    return (
        <div style={{ ...heroStyle, backgroundImage: `url(${currentImageUrl})` }}>
            <div style={overlayStyle}></div>
            <div style={contentStyle}>
                {/* TEXTO Y CTA */}
                <h1 style={{ fontSize: '5vw', minFontSize: '2.5em', margin: '0 0 10px 0' }}>
                    Simplificamos tu Compra.
                </h1>
                <p style={{ fontSize: '3.5vw', minFontSize: '1.2em', fontWeight: '300' }}>
                    Accede a inventario premium del Sur de la Florida con la mejor asesoría broker.
                </p>
                
                {/* Botón al catálogo */}
                <a href="/catalogo" style={{ textDecoration: 'none' }}> 
                    <button style={{ 
                        padding: '12px 25px', 
                        background: 'white', 
                        color: '#007bff', 
                        border: 'none', 
                        borderRadius: '4px', 
                        cursor: 'pointer', 
                        marginTop: '25px', 
                        fontWeight: 'bold', 
                        fontSize: '1.1em' 
                    }}>
                        Ver Vehículos Disponibles
                    </button>
                </a>
            </div>
        </div>
    );
}